/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Yelp24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Yelp 24">
      <path
        fill="#0E0E0E"
        d="M10.413 16.286c.274-.323.641-.395 1.035-.238.37.146.54.402.541.838.004.75.002 1.5.002 2.25h-.025c0 .75.007 1.501-.002 2.252-.006.569-.299.871-.863.816a7.332 7.332 0 0 1-3.462-1.268c-.472-.324-.51-.74-.146-1.18a414.58 414.58 0 0 1 2.92-3.47Zm3.502-.94c.238-.284.546-.39.903-.272 1.463.484 2.925.975 4.387 1.464.334.111.524.33.544.708-.068.199-.115.409-.209.595a8.268 8.268 0 0 1-1.95 2.493c-.125.109-.27.203-.419.274-.351.168-.678.098-.883-.226a327.79 327.79 0 0 1-2.516-4.042c-.213-.349-.105-.696.143-.994Zm-9.5-3.314c.162-.72.56-.899 1.243-.625a561.07 561.07 0 0 1 4.038 1.64c.424.174.611.474.592.913-.018.415-.223.677-.664.818-1.416.451-2.832.904-4.252 1.343-.564.175-.92-.018-1.047-.6-.147-1.179-.057-2.839.09-3.489Zm11.877-3.8c.384-.515.8-.564 1.275-.124a7.58 7.58 0 0 1 1.96 2.927c.227.61.025.966-.603 1.128-1.428.367-2.86.719-4.292 1.075-.086.021-.175.026-.247.036-.389-.01-.655-.196-.825-.513a.8.8 0 0 1 .064-.914c.89-1.205 1.772-2.415 2.668-3.616Zm-5.721-6.437c.695-.042.94.191.988.88.17 2.455.332 4.91.504 7.455-.025.214-.022.522-.1.808-.174.626-.796.81-1.29.382a2.806 2.806 0 0 1-.512-.614c-1.363-2.143-2.72-4.29-4.075-6.438-.391-.62-.313-.994.344-1.328 1.3-.66 2.682-1.058 4.14-1.145Z"
        className="SVG"
      />
    </g>
  </svg>
);

const SIZE_MAP = {
  sm: Yelp24,
  md: Yelp24,
  lg: Yelp24,
  xl: Yelp24,
  xxl: Yelp24,
  xxxl: Yelp24,
};

export const YelpIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'yelp-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
